<div class="container">
    <button [ngClass]="{'button-item': true, 'active': selectedLetter == letter}"
            *ngFor="let letter of letters" (click)="sendEvent(letter)">
        {{letter}}
    </button>
</div>
